import { Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import PaperLogTrainer from "@/components/paperlog/PaperLogTrainer";
import { ArrowLeft, FileClock } from "lucide-react";

export default function PaperLogs() {
  return (
    <div className="min-h-screen bg-white">
      <SiteHeader />

      <section className="max-w-4xl mx-auto px-6 pt-14 pb-6">
        <Link to="/step/6" data-testid="paperlogs-back" className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-slate-900 transition-colors mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to Step 6 (ELD & IFTA)
        </Link>
        <div className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-bold text-brand mb-3">
          <FileClock className="w-4 h-4" /> Owner-operator tools · Pro
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tighter font-black text-slate-900">Paper Log Practice</h1>
        <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">
          When your ELD goes down you fall back to paper. Practice plotting a compliant 24-hour log by hand — the app checks
          it against the Hours-of-Service rules and shows you exactly what an inspector looks for.
        </p>
      </section>

      <section className="max-w-4xl mx-auto px-6 pb-24">
        <PaperLogTrainer />
      </section>
    </div>
  );
}
